import { Job } from '@/types/job';
import JobCard from './job-card';

interface Props {
  jobs: Job[];
  className?: string;
}

export default function JobList({ jobs, className }: Props) {
  return (
    <ul className={className}>
      {jobs.map((job, index) => (
        <li key={job.companyName + job.title + index}>
          <JobCard job={job} />
        </li>
      ))}
    </ul>
  );
}
